export const CONNECTED_WALLETS_KEY = 'connectedWallets'
export const ZORA_CLAIM_CONTRACT_ENV = 'PRODUCTION'
